module.exports = __webpack_public_path__ + "img/cv.58957605.svg";